<template>
  <div class="portfoliouploadtemplate">
    <div class="pf-upload-stepper">
      <div class="pf-upload-step" :class="{'pf-upload-step-active' : actualstep >= 1 }">
        <div class="pf-upload-step-icon">
          <div class="pf-upload-step-load" :class="{'pf-upload-step-active-load' : actualstep > 1 }" />
          <font-awesome-icon icon="cloud-upload-alt" />
        </div>
        <div class="pf-upload-step-text">{{ $t('step-one-upload') }}</div>
      </div>
      <div class="pf-upload-step" :class="{'pf-upload-step-active' : actualstep >= 2 }">
        <div class="pf-upload-step-icon">
          <div class="pf-upload-step-load" :class="{'pf-upload-step-active-load' : actualstep > 2 }" />
          <font-awesome-icon icon="edit" />
        </div>
        <div class="pf-upload-step-text">{{ $t('step-two-validate') }}</div>
      </div>
      <div class="pf-upload-step" :class="{'pf-upload-step-active' : actualstep >= 3 }">
        <div class="pf-upload-step-icon">
          <div class="pf-upload-step-load" :class="{'pf-upload-step-active-load' : actualstep > 3 }" />
          <font-awesome-icon icon="bezier-curve" />
        </div>
        <div class="pf-upload-step-text">{{ $t('step-two-typologies') }}</div>
      </div>
      <div class="pf-upload-step" :class="{'pf-upload-step-active' : actualstep >= 4 }">
        <div class="pf-upload-step-icon">
          <font-awesome-icon icon="map-marked-alt" />
        </div>
        <div class="pf-upload-step-text">{{ $t('step-three-localize') }}</div>
      </div>
      <button class="brains-type1-btn" @click="resetportfolio()">{{ $t("portfoliosSelector.new") }}</button>
    </div>
    <div class="steepcomponent mt-3">
      <portfoliofilec v-if="actualstep === 1" class="porfolio-upload-comp-container" />
      <portfolioexcelc v-if="actualstep === 2" ref="excelview" :portfolioname="portname" />
      <portfoliotypologiesc v-if="actualstep === 3" :portfolioname="portname" :matchdata="excelColumnsMatch" :possible-typos="clientTipologies" />
      <portfoliowaitj v-if="actualstep >= 4" :portfolioname="portname" />
    </div>
    <div class="currentjobs mt-2">
      <div class="jobs-progress-counter">
        <div v-if="loading" class="portfolio-loaderq" />
        {{ $t("progress") }}: {{ actualstep }} / 5
      </div>
      <div v-for="bar in alljobs" :key="bar.portfolioname" class="jobitem">
        <div>
          <!--<span style="font-weight: bold; color: #F56C6C; margin-right: 10px;">Number of errors: {{ job.totalErrors }}</span>-->
          <span class="jobs-progress-portfolio-name">{{ bar.portfolioname }} </span> <span class="jobs-progress-portfolio-msginfoport">( {{ bar.date }} - {{ $t(bar.msg) }} )</span>
        </div>
        <div>
          <el-progress :percentage="bar.progress" :stroke-width="4" stroke-linecap="square" color="#009999" :status="validateStatus(bar)" />
        </div>
      </div>
    </div>
    <modal v-model="showcellserror" class="cells-error-modal">
      <div class="cells-error-title">{{ $t('portfoliosSelector.uploadingWithErrors') }}</div>
      <ul class="cells-error-content">
        <li v-for="(item, index) in cellserror" :key="index">Row {{ item[0] }} // Cell {{ item[1] }} is invalid ({{ item[2] }})</li>
      </ul>
      <div class="cells-error-btncontrol">
        <button class="brains-type1-btn" @click="showcellserror = false">{{ $t('userData.accept') }}</button>
      </div>
    </modal>
  </div>
</template>
<script>
import portfoliofilec from '@/components/portfoliofileupload'
import portfolioexcelc from '@/components/portfolioexcelview'
import portfoliotypologiesc from '@/components/portfoliotypologiesc'
import portfoliowaitj from '@/components/portfoliowaitforjob'
import modal from '@/components/designComponents/modal'
import { mapState } from 'vuex'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
export default {
  name: 'Portfoliouploadc',
  components: { portfoliofilec, modal, portfolioexcelc, portfoliowaitj, portfoliotypologiesc },
  data() {
    return {
      loading: false,
      alljobs: [],
      cellserror: [],
      showcellserror: false,
      connection: null,
      onportfolioerrorhandler: null,
      onportfoliojobhandler: null,
      onportfoliostephandler: null,
      onportfoliovalidaterowshandler: null,
      onportfolioloaddatahandler: null
    }
  },
  computed: {
    ...mapState('portfolio', {
      actualstep: (state) => state.uploadportfolio.actualstep
    }),
    ...mapState('user', {
      token: (state) => state.token
    })
  },
  created() {
    const vm = this
    if (vm.connection === null) {
      vm.connection = new HubConnectionBuilder()
        .withUrl(window._env_.VUE_APP_BRAINS_API.replace('/api', '/portfolio-hub'), { accessTokenFactory: () => vm.token })
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Information)
        .build()
      vm.constart()

      vm.onportfolioerrorhandler = (dataj) => {
        vm.handleportfolioerror(dataj)
      }
      vm.connection.on('onportfolioerror', vm.onportfolioerrorhandler)

      vm.onportfoliojobhandler = (dataj) => {
        vm.handleportfoliojob(dataj)
      }
      vm.connection.on('onportfoliojob', vm.onportfoliojobhandler)

      vm.onportfoliostephandler = (dataj) => {
        vm.handleportfoliostep(dataj)
      }
      vm.connection.on('onnextstep', vm.onportfoliostephandler)

      vm.onportfoliovalidaterowshandler = (dataj) => {
        vm.handleportfoliovalidaterows(dataj)
      }
      vm.connection.on('onportfoliovalidaterows', vm.onportfoliovalidaterowshandler)

      vm.onportfolioloaddatahandler = (dataj) => {
        vm.handleportfoliodata(dataj)
      }
      vm.connection.on('onportfolioloaddata', vm.onportfolioloaddatahandler)

      vm.connection.onclose(function() {
        console.log('porthub close')
      })
    }
  },
  beforeDestroy() {
    const vm = this
    // vm.actualstep = 1
    if (vm.connection !== null) {
      vm.connection.off('onportfolioerror', vm.onportfolioerrorhandler)
      vm.connection.off('onportfoliojob', vm.onportfoliojobhandler)
      vm.connection.off('onnextstep', vm.onportfoliostephandler)
      vm.connection.off('onportfoliovalidaterows', vm.onportfoliovalidaterowshandler)
      vm.connection.stop()
      vm.connection = null
    }
  },
  methods: {
    async constart() {
      const vm = this
      await vm.connection.start()
      vm.connection.invoke('SendMessage', 'kk')
    },
    validateStatus(bar) {
      if (bar.msg2) {
        return 'exception'
      } else {
        return 'success'
      }
    },
    resetportfolio() {
      this.$store.dispatch('portfolio/startnewportfolio')
    },
    handleportfoliojob(job) {
      const vm = this
      const actjob = JSON.parse(job)
      const msgjobs = vm.alljobs.filter((it) => it.portfolioname === actjob.portfolioname)
      vm.loading = true
      console.log(actjob)
      if (!!actjob.msg2 && actjob.msg2 === 'rowsError') {
        vm.cellserror = actjob.errorsList
        vm.showcellserror = true
      }

      if (msgjobs.length === 0) {
        vm.alljobs.push(actjob)
      } else {
        const indexOfItem = vm.alljobs.indexOf(msgjobs[0])
        vm.$set(vm.alljobs, indexOfItem, actjob)
      }
    },
    handleportfoliostep(step) {
      const vm = this
      const actjob = JSON.parse(step)
      const actportdata = {
        actualstep: actjob.step,
        portfolioname: actjob.portfolioname
      }
      if (actjob.step > 4) {
        actportdata.actualstep = 5
        vm.$store.dispatch('portfolio/changeportfoliostep', actportdata)
        vm.$message({
          showClose: true,
          message: this.$t('portfolio-loaded') + ' -> ' + actjob.portfolioname,
          type: 'success'
        })
      } else if (actjob.step === 3) {
        vm.excelColumnsMatch = actjob.matchColumns
        vm.clientTipologies = actjob.excelTypos
        vm.portname = actjob.portfolioname
        vm.$store.dispatch('portfolio/changeportfoliostep', actportdata)
      } else {
        setTimeout(() => {
          vm.portname = actjob.portfolioname
          vm.$store.dispatch('portfolio/changeportfoliostep', actportdata)
        }, 200)
      }
      setTimeout(() => {
        vm.loading = false
      }, 200)
    },
    handleportfoliodata(data) {
      this.$store.dispatch('portfolio/loadbrainsdata', data)
    },
    handleportfoliovalidaterows(rows) {
      const vm = this
      const actjob = JSON.parse(rows)
      setTimeout(() => {
        vm.$refs.excelview.activatebuttons(true)
        vm.$refs.excelview.setviewdata(actjob.rows, actjob.headersections, actjob.prematch)
        vm.loading = false
      }, 500)
    },
    handleportfolioerror(dataj) {
      // debugger
      const vm = this
      const data = JSON.parse(dataj)
      vm.loading = false
      // vm.$alert(data.msg2 || data.msg, 'Warning', {
      //   confirmButtonText: 'OK'
      // })
      if (data.msg === 'cellsError') {
        vm.cellserror = data.msg2
        vm.showcellserror = true
      } else if (data.msg === 'ValidationError' && vm.actualstep === 2) {
        vm.$refs.excelview.showvalidationerror(data.msg2)
      } else {
        vm.$message({
          showClose: true,
          message: this.$t('error portfolio'),
          type: 'error'
        })
      }

      const msgjobs = vm.alljobs.filter((it) => it.portfolioname === data.portfolioname)
      if (msgjobs.length > 0) {
        const indexOfItem = vm.alljobs.indexOf(msgjobs[0])
        vm.$set(vm.alljobs, indexOfItem, data)
      }
      vm.$refs.excelview.activatebuttons(true)
    }
  }
}
</script>
<style lang="scss" scoped>
.pf-upload-stepper {
  display: flex;
  width: 90%;
  justify-content: space-around;
  white-space: nowrap;

  .pf-upload-step {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    position: relative;

    .pf-upload-step-icon {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;

      & svg {
        background-color: white;
        color: rgba(0, 0, 0, 0.85);
        width: 25px;
        height: 25px;
        fill: none;
        stroke: rgba(0, 0, 0, 0.85);
        stroke-miterlimit: 10;
        stroke-width: 1.3px;
      }
    }

    .pf-upload-step-text {
      display: flex;
      font-size: 16px;
      font-family: 'Montserrat-ExtraBold',sans-serif;
      justify-content: center;
    }

    .pf-upload-step-load {
      position: absolute;
      height: 2px;
      background-color: #C0C4CC;
      top: 15px;
      left: 50%;
      right: -50%;
      margin: 0 25px;
    }
  }

  .pf-upload-step-active {
    color: #1e3cff !important;

    .pf-upload-step-icon svg {
      color: #1e3cff !important;
      stroke: #1e3cff !important;
    }
  }

  .pf-upload-step-active-load {
    background-color: #1e3cff !important;
  }
}

.porfolio-upload-comp-container {
  width: 500px;
  margin: 0 10px;
}

.portfolio-loaderq {
  border: 5px solid #f3f3f3; /* Light grey */
	border-top: 5px solid #1e3cff;
	border-radius: 50%;
	height: 20px;
	width: 20px;
	animation: spin 2s linear infinite;
  margin-right: 15px;
}

.cells-error-title {
  font-family: 'Montserrat-SemiBold',sans-serif;
  font-size: 15px;
  margin-bottom: 10px;
  border-bottom: 2px solid #1e3cff;
  padding: 10px 0;
}
.cells-error-content {
  list-style-type: circle;
  font-size: 13px;
  padding-left: 20px;
  padding-bottom: 30px;

  li {
    line-height: 20px;
  }
}
.cells-error-btncontrol {
  gap: 20px;
  display: flex;
  position: absolute;
  bottom: 20px;
  width: 100%;
  align-items: center;
  justify-content: right;
  right: 50px;
}

.portfoliouploadtemplate {
  padding: 5px;
  width: 100%;
  height: 100vh;

  .container-close-btn-portfolio-upload {
    display: flex;
    justify-content: flex-end;
    padding-right: 25px;
    padding-top: 10px;

    div {
      cursor: pointer;

      svg {
        font-size: 22px;
        color: rgb(194, 194, 194);

        &:hover {
          color: #333333;
        }
      }
    }
  }

  .stepper {
    font-family: 'Montserrat-ExtraBold',sans-serif;
  }

  .steps-components-container {
    width: 100%;

    .step-container {
      &--first {
        margin-top: 20px;
        width: 33%;
        display: flex;
        justify-content: flex-start;
        padding-right: 45px;
        padding-left: 45px;
      }
    }
  }
}

.steepcomponent {
  height: calc(100vh - 160px);
  overflow-y: scroll;
  overflow-x: hidden;
  padding-bottom: 55px;
}

.currentjobs {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: white;
  z-index: 1301;
  padding: 10px 5px;
  box-shadow: 4px 0px 0px 1px lightgrey;
}

.jobitem {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  align-items: center;

  div:nth-child(2) {
    width: 30%;
  }
}

.jobs-progress-counter {
  font-size: 18px;
  margin-bottom: 5px;
  font-family: "Montserrat-SemiBold",sans-serif;
  color: rgb(194, 194, 194);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 40px;
}

.jobs-progress-portfolio-name {
  font-weight: 600;
  font-family: "Montserrat-SemiBold",sans-serif;
  font-size: 20px;
  padding-left: 15px;
}

.jobs-progress-portfolio-msginfoport {
  font-weight: 200;
  font-family: "Montserrat-SemiBold",sans-serif;
  font-size: 10px;
  padding-left: 15px;
}
</style>

<style lang="scss">
.cells-error-modal > .brains-asset-data-modal--content {
  padding: 20px !important;
}

.el-progress-bar {
  .el-progress-bar__outer {
    border-radius: 25px !important;
    background-color: lightgrey;

    .el-progress-bar__inner {
      border-radius: 0px !important;
    }
  }
}
</style>
